/**
 * Concierge Manual Mode — frontend rendering flag accessor.
 *
 * Per ADR-CONCIERGE-PHASE-A. Read by EventHome and ConciergeAdminPage
 * to gate Hybrid-Mode-implying surfaces.
 *
 * Independent from the Event Home and Operations Center flags
 * (see eventHomeFlag.js / featureFlag.js) so Manual Mode can be
 * toggled without disturbing the Event Home routing fork.
 *
 * Kept as a single-export module — matches the per-feature flag
 * convention in this directory. CRA partially inlines REACT_APP_*
 * env vars at babel-transform time, making direct env mutation in
 * tests unreliable; per-feature modules are the stable mockable
 * equivalent.
 *
 * Default: TRUE. Manual Mode is the current production reality.
 * To enable Hybrid Mode (Phase D), set
 *   REACT_APP_CONCIERGE_MANUAL_MODE=false
 * and rebuild the frontend bundle.
 *
 * The backend remains mode-agnostic; this flag is a consumer-side
 * rendering concern only.
 */

export function isConciergeManualMode() {
  const raw = process.env.REACT_APP_CONCIERGE_MANUAL_MODE;
  // Defensive default: any value other than the literal string "false"
  // resolves to Manual Mode. Unset, empty, or any unexpected value all
  // collapse to TRUE so production cannot accidentally fall through to
  // Hybrid Mode by misconfiguration.
  if (raw === undefined || raw === null) return true;
  return String(raw).toLowerCase() !== 'false';
}
